import strings from "global/constants/StringConstants";
import { isPhoneValid, isTruthy } from "helpers/methods";
import { UserData } from "models/interfaces";

export const getProfileFormData = (data?: any) => {
  return {
    name: {
      value: data?.name ?? "",
      error: "",
    },
    email: {
      value: data?.email ?? "",
      error: "",
    },
    contactNo: {
      value: data?.contactNo ?? "",
      error: "",
    },
    role: {
      value: data?.role ?? "",
      error: "",
    },
    roleIds: {
      value: data?.roleIds ?? [],
      error: "",
    },
    profilePicture: data?.profilePicture ?? "",
    parentEmail: data?.parentEmail ?? "",
  } as UserData;
};

export const validateForProfileForm = (personalDataForm: UserData) => {
  const emailRegex = strings.regex;

  let errors = personalDataForm;
  let isValid = true;
  const name = isTruthy(personalDataForm.name.value.trim());
  const contactNo = personalDataForm.contactNo.value;
  const email = isTruthy(personalDataForm.email.value);
  if (!name && !contactNo && !email) {
    errors.name.error = "Please enter name";
    errors.contactNo.error = "Please enter phone number";
    errors.email.error = "Please enter email";
    isValid = false;
  }
  if (!name) {
    errors.name.error = "Please enter name";
    isValid = false;
  }
  if (!contactNo) {
    errors.contactNo.error = "Please enter phone number";
    isValid = false;
  }
  if (!isPhoneValid(contactNo)) {
    errors.contactNo.error = "Please enter a valid contact number";
    isValid = false;
  }
  if (!email) {
    errors.email.error = "Please enter email";
    isValid = false;
  }
  if (email && !emailRegex.test(personalDataForm.email.value)) {
    errors.email.error = "Please enter valid email";
    isValid = false;
  }
  return { isValid, errors };
};
